import { useSearchParams } from 'react-router-dom';
import MapaPiscinas from './Piscinas';
import MapaTelecom from './MapaTelecom';

export default function Mapas() {
  const [searchParams] = useSearchParams();
  const esTelecom = searchParams.get('tab') === 'telecom';

  return (
    <div className="h-full w-full overflow-hidden">
      {esTelecom ? <MapaTelecom /> : <MapaPiscinas />}
    </div>
  );
}